import { Route, Routes } from 'react-router-dom';
import React, { Suspense } from "react";
import Dashboard from '../../../views/Dashboard/Dashboard'
import Proyectos from '../../../views/Dashboard/Proyectos/Proyectos';
const DashboardRoute = () => {
    return (
        <Routes>
            <Route exact path="/dashboard"
                   element={
                       <Suspense fallback={<>skeleton</>}>
                           <Dashboard></Dashboard>
                       </Suspense>
                   }>
            </Route>
            <Route exact path="/dashboard/proyectos"
                   element={
                       <Suspense fallback={<>skeleton</>}>
                           <Proyectos></Proyectos>
                       </Suspense>
                   }>
            </Route>
        </Routes>
    )

}

export default DashboardRoute
